import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Modal } from '@grandvisionhq/common';
import AddAddress from '../../../../AddressBook/AddAddress/AddAddress.js';
import { AddressBookModalFooter } from './AddressBookModalFooter.js';
import { SelectAddress } from '../SelectAddress/Layout.js';

const animationOffset = 100;
const variants = {
    LTR: {
        x: animationOffset,
        opacity: 0
    },
    middle: {
        x: 0,
        opacity: 1
    },
    RTL: {
        x: -animationOffset,
        opacity: 0
    }
};
const animationProps = {
    variants,
    animate: 'middle',
    transition: {
        x: {
            type: 'spring',
            stiffness: 2000,
            damping: 100,
            duration: 0.1
        },
        opacity: {
            duration: 0.2
        }
    }
};
var AddressBookModal = (_param)=> {
    var { addressForm , addressSummary , handleOnAddAddress , handleAdressSelect , isAddViewActive , isAddCallLoading , onAddAddress , secondaryIconOptions , selectedAddress , setSelectedAddress , labels , isOpen  } = _param, modalProps = swcHelpers.objectWithoutProperties(_param, [
        "addressForm",
        "addressSummary",
        "handleOnAddAddress",
        "handleAdressSelect",
        "isAddViewActive",
        "isAddCallLoading",
        "onAddAddress",
        "secondaryIconOptions",
        "selectedAddress",
        "setSelectedAddress",
        "labels",
        "isOpen"
    ]);
    return React.createElement(Modal, swcHelpers.extends({}, modalProps, {
        "data-t": "address-book-modal",
        className: "address-book-modal",
        isOpen: isOpen,
        secondaryIconOptions: secondaryIconOptions,
        showIcon: true,
        title: labels.title,
        footer: /*#__PURE__*/ React.createElement(AddressBookModalFooter, {
            handleOnAddAddress: handleOnAddAddress,
            isLoading: isAddCallLoading,
            isAddViewActive: isAddViewActive,
            labels: labels,
            handleAdressSelect: handleAdressSelect
        })
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        initial: false,
        exitBeforeEnter: true
    }, isAddViewActive ? /*#__PURE__*/ React.createElement(motion.div, swcHelpers.extends({
        key: "add"
    }, animationProps, {
        initial: "LTR",
        exit: "LTR"
    }), /*#__PURE__*/ React.createElement(AddAddress, {
        addressForm: addressForm,
        onSubmit: onAddAddress
    })) : /*#__PURE__*/ React.createElement(motion.div, swcHelpers.extends({
        key: "select"
    }, animationProps, {
        initial: "RTL",
        exit: "RTL"
    }), /*#__PURE__*/ React.createElement(SelectAddress, {
        addressSummary: addressSummary,
        selected: selectedAddress,
        onChange: setSelectedAddress,
        title: labels.title
    })))));
};

export { AddressBookModal };
//# sourceMappingURL=AddressBookModal.js.map
